var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{class:{ checkbox__bordered: _vm.bordered },attrs:{"label":_vm.label,"value":_vm.value,"input-value":_vm.inputValue,"color":_vm.color,"hide-details":"","outlined":"","dense":""},on:{"change":_vm.handleInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }